// Toggle Shopify's buyer-consent banner on the product page based on
// whether a selling plan (subscription) is currently selected.
// Shopify renders <small id="shopify-buyer-consent"> inside the dynamic
// checkout button area; its `hidden` class is supposed to be kept in sync
// with the form's selling_plan value, but Appstle's radio widget does not
// trigger Shopify's internal handler reliably.

(function () {
  function updateConsent() {
    const selected = document.querySelector('input[name="selling_plan"]:checked');
    const hasPlan = !!(selected && selected.value);

    document
      .querySelectorAll('.product-form__buttons #shopify-buyer-consent')
      .forEach((el) => {
        if (hasPlan) {
          el.classList.remove('hidden');
          el.removeAttribute('aria-hidden');
        } else {
          el.classList.add('hidden');
          el.setAttribute('aria-hidden', 'true');
        }
      });
  }

  function onChange(event) {
    const target = event.target;
    if (!target || !target.name) return;
    if (
      target.name === 'selling_plan' ||
      target.name === 'selling_plan_radio' ||
      target.name === 'purchase_option'
    ) {
      // Small delay so Appstle can sync the hidden selling_plan input first.
      setTimeout(updateConsent, 0);
    }
  }

  function init() {
    document.addEventListener('change', onChange, true);
    // Initial pass + a couple of retries to cover Appstle's async init.
    updateConsent();
    [300, 1000].forEach((d) => setTimeout(updateConsent, d));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      setTimeout(updateConsent, 0);
    });
  }
})();
